import { CheckCircle2 } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/logo.png";

const Footer = () => {
  return (
    <>
      <footer className="bg-gray-900 text-gray-300 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            <div>
              <div className="flex items-center space-x-2 mb-4">
                <Link to="/">
                  <img src={Logo} alt="logo" className="h-12 md:h-14" />
                </Link>
              </div>
              <p className="text-sm">
                Connecting Indian farms to global markets with quality and
                integrity.
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-white mb-4">Quick Links</h4>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link
                    to="/about"
                    className="hover:text-emerald-400 transition-colors"
                  >
                    About Us
                  </Link>
                </li>
                <li>
                  <Link
                    to="/services"
                    className="hover:text-emerald-400 transition-colors"
                  >
                    Services
                  </Link>
                </li>
                <li>
                  <Link
                    to="/responsibilities"
                    className="hover:text-emerald-400 transition-colors"
                  >
                    Our Responsibilities
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold text-white mb-4">Other Pages</h4>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link
                    to="/terms-conditions"
                    className="hover:text-emerald-400 transition-colors"
                  >
                    Terms & Conditions
                  </Link>
                </li>
                <li>
                  <Link
                    to="/privacy-policy"
                    className="hover:text-emerald-400 transition-colors"
                  >
                    Privacy Policy
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold text-white mb-4">Newsletter</h4>
              <p className="text-sm">
                Subscribe to our newsletter for the latest updates and offers.
              </p>
              <form className="mt-4 flex">
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="w-full px-4 py-2 rounded-l-md focus:outline-none focus:ring-2 focus:ring-emerald-500"
                />
                <button
                  type="submit"
                  className="bg-emerald-500 text-white px-4 py-2 rounded-r-md hover:bg-emerald-600 transition-colors"
                >
                  Subscribe
                </button>
              </form>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-8 text-center text-sm">
            <p>
              &copy; 2026 Reco Agro Traders. All rights reserved.
              <br />
              Powered by{" "}
              <a
                href="https://innorviatechnology.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-emerald-400 transition-colors"
              >
                Innorvia Technology
              </a>
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
